import service from "../plugins/service"
import { createFormData } from '@/plugins/formData'

const base = '/afterSale/'

export const getOrders = (page, size, p) => {
  const data = createFormData(p)
  return service({
    url: `${base}order/list/${page}/${size}`,
    method: 'POST',
    data
  })
}

export const createOrderNo = () => {
  return service({
    url: `${base}create/orderNo`,
    method: 'GET'
  })
}

export const addOrder = o => {
  const data = createFormData(o)

  return service({
    url: `${base}create/order`,
    method: 'POST',
    data
  })
}

export const updateOrder = o => {
  const data = createFormData(o)

  return service({
    url: `${base}update/order`,
    method: 'PUT',
    data
  })
}

export const setOrderStatus = o => {
  const data = createFormData(o)

  return service({
    url: `${base}update/orderStatus`,
    method: 'PUT',
    data
  })
}

export const cancelOrder = o => {
  const data = createFormData(o)
  
  return service({
    url: `${base}cancel/order`,
    method: 'PUT',
    data
  })
}

export const searchOrderOperators = o => {
  const data = createFormData(o)
  
  return service({
    url: `${base}order/operator`,
    method: 'POST',
    data
  })
}

export const getDistance = o => {
  const data = createFormData(o)

  return service({
    url: `${base}order/distance`,
    method: 'POST',
    data
  })
}

export const f = data => {
  return service({
    url: '/afterSale/fwd/serviceManList',
    method: 'POST',
    data
  })
}

export const u = data => {
  return service({
    url: '/afterSale/fwd/serviceManUpdate',
    method: 'POST',
    data
  })
}